var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkSlant = function SvgLinkSlant(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA580C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.414 6.586 6.586 9.414m.471-5.185.471-.472a3.333 3.333 0 1 1 4.715 4.714l-.472.472M4.23 7.057l-.472.471a3.333 3.333 0 1 0 4.714 4.715l.472-.472"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkSlant);
export default ForwardRef;